/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud # Usage This API is used in the `https://yrityksille.elisa.fi/` pages. # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MediumCharacteristic } from './mediumCharacteristic.js';


/**
 * A contact medium used to reach the customer.
 */
export interface ContactMedium { 
    /**
     * Type of contact medium.
     */
    mediumType: ContactMedium.MediumTypeEnum;
    characteristic: MediumCharacteristic;
    /**
     * Polymorphic type discriminator for the contact medium.
     */
    type: string;
}
export namespace ContactMedium {
    export type MediumTypeEnum = 'postalAddress' | 'email' | 'telephone' | 'User1Email' | 'User2Email' | 'User3Email' | 'User4Email' | 'User5Email';
    export const MediumTypeEnum = {
        postalAddress: 'postalAddress' as MediumTypeEnum,
        email: 'email' as MediumTypeEnum,
        telephone: 'telephone' as MediumTypeEnum,
        User1Email: 'User1Email' as MediumTypeEnum,
        User2Email: 'User2Email' as MediumTypeEnum,
        User3Email: 'User3Email' as MediumTypeEnum,
        User4Email: 'User4Email' as MediumTypeEnum,
        User5Email: 'User5Email' as MediumTypeEnum
    };
}


